module.exports = __webpack_public_path__ + "static/media/cc.244dd802.svg";